module.exports = __webpack_public_path__ + "img/breakdown-bg.29a02d42.svg";